import React from "react";
import Link from "next/link";
import { withImageResizer } from "lib/utils";
import LocationIcon from "../../Icons/LocationIcon";
import ArrowRight from "../../Icons/ArrowRight";

const ChurchCarouselItemSmallScreen = ({
  position,
  itemData,
  idx,
  isChurchpage = false,
}) => {
  const createItem = ({ position, itemData, idx }) => {
    const item = {
      styles: {},
      data: itemData,
    };
    switch (position) {
      case position - 1:
      case position + 1:
        item.styles = {
          ...item.styles,
        };
        break;
      case position:
        break;
      default:
        item.styles = { ...item.styles, ...{ display: "none" } };
        break;
    }
    return item;
  };
  const {
    data: { title, account, descriptionParsed, styles, images },
  } = createItem({ position, itemData, idx });
  return (
    <>
      <Link
        href={`/?churchSlug=${account.urlName}`}
        as={`/kirkko/${account.urlName}`}
      >
        <a
          className={`mr-2 w-full  ${!isChurchpage && "min-w-[245px]"}  ${
            isChurchpage && "max-w-[180px] phone:min-w-[245px]"
          }`}
        >
          <li style={{ ...styles }} className="group rounded-10 w-full mr-2">
            <img
              alt={"kuva " + account.name}
              className={`bg-gray-100 rounded-10  w-full  ${
                isChurchpage ? "h-[262px]" : "h-[368px]"
              } object-cover object-bottom `}
              src={
                images?.card
                  ? withImageResizer(images.card, 640)
                  : "/images/church-icon.png"
              }
            ></img>
            <article className="rounded-lg bg-white-100">
              <h2 className="py-1.5 text-bodyText font-bold bg-white-100 truncate-text two-lines">
                {account.name}
              </h2>
              <div className="flex justify-between pb-5">
                {descriptionParsed && descriptionParsed.data?.address && (
                  <div className="">
                    <p className="flex items-center min-h-[55px]">
                      <LocationIcon height={26.7} width={20.03} />
                      <span className="px-2.5 pb-0.5 text-gray text-sm font-bold">
                        {descriptionParsed.data.address}
                      </span>
                    </p>
                  </div>
                )}
              </div>
            </article>
          </li>
        </a>
      </Link>
    </>
  );
};

export default ChurchCarouselItemSmallScreen;
